var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenralIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67174 11.6134C4.41138 12.8738 3.57113 13.2939 1.89062 11.6134C0.210104 9.93286 0.630221 9.09262 1.89058 7.83226C3.15095 6.57189 4.01745 6.17803 5.67171 7.83229C7.32596 9.48655 6.93211 10.3531 5.67174 11.6134Z",
    fill: "#347AE2",
    stroke: "#347AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6134 5.6717C10.353 6.93207 9.51278 7.35218 7.83227 5.67167C6.15175 3.99115 6.57187 3.15091 7.83223 1.89054C9.0926 0.630181 9.9591 0.236322 11.6134 1.89058C13.2676 3.54484 12.8738 4.41134 11.6134 5.6717Z",
    fill: "#F3BE02",
    stroke: "#F3BE02",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8077 11.8665C16.5474 13.1269 15.7071 13.547 14.0266 11.8665C12.3461 10.186 12.7662 9.34573 14.0266 8.08537C15.2869 6.82501 16.1534 6.43115 17.8077 8.0854C19.462 9.73966 19.0681 10.6062 17.8077 11.8665Z",
    fill: "#D57300",
    stroke: "#D57300",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6134 17.5555C10.353 18.8159 9.51278 19.236 7.83227 17.5555C6.15175 15.8749 6.57187 15.0347 7.83223 13.7743C9.0926 12.514 9.9591 12.1201 11.6134 13.7744C13.2676 15.4286 12.8738 16.2951 11.6134 17.5555Z",
    fill: "#00E096",
    stroke: "#00E096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenralIcon);
export default __webpack_public_path__ + "static/media/genral_icon.045acfd9199d179456bbffd2e2d35af2.svg";
export { ForwardRef as ReactComponent };